"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-unused-expressions */
const use_debounce_1 = require("use-debounce");
const googlePlacesAutocompleteRequestBuilder_1 = __importDefault(require("../helpers/googlePlacesAutocompleteRequestBuilder"));
const useGooglePlacesFetchSuggestions = (arg) => {
    const { autocompletionRequest, debounce, minLengthAutocomplete, placesService, sessionToken } = arg;
    const [fetchSuggestions] = (0, use_debounce_1.useDebouncedCallback)((value, cb) => {
        if (!placesService)
            return cb([]);
        if (value.length < minLengthAutocomplete)
            return cb([]);
        const autocompletionReq = Object.assign({}, autocompletionRequest);
        placesService.getPlacePredictions((0, googlePlacesAutocompleteRequestBuilder_1.default)(autocompletionReq, value, sessionToken), (suggestions) => {
            cb((suggestions || []).map((suggestion) => ({
                label: suggestion.description,
                value: suggestion,
            })));
        });
    }, debounce);
    return fetchSuggestions;
};
exports.default = useGooglePlacesFetchSuggestions;
//# sourceMappingURL=useGooglePlacesFetchSuggestions.js.map